import { Component, Input, OnDestroy } from '@angular/core';

import { PORTAL_MEDIA_ALL_STATE } from 'rev-shared/bootstrap/AppStateNames';
import { UserContextService } from 'rev-shared/security/UserContext.Service';
import { SearchService } from 'rev-portal/search/Search.Service';

import { SortRecommended } from 'rev-portal/search/SearchConstants';
import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';
import { MediaStateService } from 'rev-portal/media/MediaState.Service';

import styles from './VideoPlayback.module.less';

@Component({
	selector: 'video-playback-recommended',
	templateUrl: './VideoPlaybackRecommended.Component.html',
	host: {
		'[class]': 'styles.recommended'
	}
})
export class VideoPlaybackRecommendedComponent implements OnDestroy {
	@Input() public videoId: string;

	public readonly PORTAL_MEDIA_ALL_STATE = PORTAL_MEDIA_ALL_STATE;
	public readonly styles = styles;
	private readonly accountId = this.UserContext.getAccount().id;
	public readonly isGuest = this.UserContext.isGuest();
	public readonly userId = this.UserContext.getUser().id;
	public readonly hasMediaEditAuth = !!this.SecurityContext.checkAuthorization('media.edit');

	private scrollId: string = '';
	public pauseInfiniteScroll: boolean;
	public scrollExpired: boolean;
	public videos: any[] = [];
	public srefParams: any;

	constructor(
		private readonly SearchService: SearchService,
		private readonly UserContext: UserContextService,
		private readonly SecurityContext: SecurityContextService,
		public readonly MediaState: MediaStateService
	) { }

	public ngOnInit(): void {
		this.srefParams = {
			contextVideoId: this.videoId,
			sortField: SortRecommended,
			desc: true
		};
	}

	public ngOnDestroy(): void {
		this.SearchService.closeScrollId(this.accountId, this.scrollId);
	}

	public loadNextPage(): Promise<void> {
		this.pauseInfiniteScroll = true;
		return this.SearchService.getVideos(
			{
				accountId: this.accountId,
				contextVideoId: this.videoId,
				sortField: SortRecommended,
				sortAscending: false,
				count: 25,
				scrollId: this.scrollId
			})
			.then(result => {
				this.scrollId = result.scrollId;
				this.videos = this.videos ? [...this.videos, ...result.videos] : result.videos;
				this.pauseInfiniteScroll = this.videos.length >= result.totalHits;
			})
			.catch(e => {
				this.pauseInfiniteScroll = true;
				this.scrollExpired = e?.status === 404;
			});
	}

	public resetScroll(): void {
		this.videos = [];
		this.scrollId = null;
		this.scrollExpired = false;
		this.pauseInfiniteScroll = false;
	}
}

